module.exports = __webpack_public_path__ + "img/cap_loading.8ba8ce24.gif";